import { useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { FC, memo, useEffect, useState } from "react";

import { ReduxState } from "../types/redux.types";
import { IAreaOfAdvertising } from "../types/resource.types";
import { GenericFunction } from "../types/generic.types";

const AreaOfAdvertising: FC<AreaOfAdvertisingProps> = ({ onSelectAdvertising, intialValue = [] }) => {
  const areaEnums = useSelector<ReduxState, IAreaOfAdvertising>((state) => state.enums.areaOfAdvertising);

  const [selectedAreaOfAdvertising, setSelectedAreaOfAdvertising] = useState<any[]>([]);
  const [areaOfAdvertisingEnumsList, setAreaOfAdvertisingEnumsList] = useState<any[]>([]);

  const handleChange = (values: any[] = []) => {
    let selectedAdvertising = values.map((value: any) => {
      return `${value.categoryKey}.${value.subCategoryKey}`;
    });
    onSelectAdvertising(selectedAdvertising);
    setSelectedAreaOfAdvertising(values);
  };

  useEffect(() => {
    if (areaEnums) {
      const areaOfAdvertisingArray = Object.entries(areaEnums)
        .map((category) => {
          const asdf = Object.entries(category[1].categories).reduce((acc, subCategory) => {
            return [
              ...acc,
              { categoryKey: category[0], subCategoryKey: subCategory[0], subCategoryValue: subCategory[1].en },
            ];
          }, [] as any);

          return asdf;
        })
        .flat();

      setAreaOfAdvertisingEnumsList(areaOfAdvertisingArray);

      if (intialValue.length && areaOfAdvertisingArray.length) {
        const intialValueArray = intialValue.map((val: string) => {
          return {
            categoryKey: val.split(".")[0],
            subCategoryKey: val.split(".")[1],
          };
        });
        const selectedFromAreaEnums = intialValueArray.map((value) => {
          const selectIntialFromEnums = areaOfAdvertisingArray.find((x) => {
            return x.categoryKey === value.categoryKey && x.subCategoryKey === value.subCategoryKey;
          });
          return selectIntialFromEnums;
        });
        setSelectedAreaOfAdvertising(selectedFromAreaEnums);
      }
    }
  }, [areaEnums]);

  return (
    <Autocomplete
      multiple
      value={selectedAreaOfAdvertising}
      onChange={(_, value) => handleChange(value)}
      id="grouped-demo"
      options={areaOfAdvertisingEnumsList.sort((a, b) => -b.categoryKey.localeCompare(a.categoryKey))}
      groupBy={(option) => option.categoryKey}
      getOptionLabel={(option) => option.subCategoryValue}
      renderInput={(params) => <TextField {...params} label="Advertising" variant="outlined" />}
    />
  );
};

interface AreaOfAdvertisingProps {
  onSelectAdvertising: GenericFunction;
  intialValue?: string[];
}

export default memo(AreaOfAdvertising);
